const ANALYTICS_REPORT_BASE =
  'https://analytics.okton.com.br/dashboard/my-reports/generate';

export function analyticsReportUrl(
  reportId: string,
  refresh: number = Date.now(),
): string {
  if (!/^[1-9][0-9]*$/.test(reportId)) {
    throw new Error('Relatório inválido.');
  }

  if (!Number.isSafeInteger(refresh) || refresh < 1) {
    throw new Error('Identificador de atualização inválido.');
  }

  return `${ANALYTICS_REPORT_BASE}/${reportId}?source=okto&refresh=${refresh}`;
}
